import { differenceInDays } from "date-fns";
import * as Yup from "yup";

export const billingHistoryValidationSchema = Yup.object().shape({
  account: Yup.string().required("Account is required"),
  // startDate: Yup.date().required("Start date is required").nullable(),
  // endDate: Yup.date()
  //   .required("End date is required")
  //   .min(Yup.ref("startDate"), "End date can't be before start date")
  //   .nullable(),

  startDate: Yup.string()
    .required("Start Date is required")
    .test(
      "is-before-end",
      "Start Date cannot be after End Date",
      function (startDate) {
        const { endDate } = this.parent;
        return endDate ? new Date(startDate) <= new Date(endDate) : true;
      }
    )
    .test(
      "is-in-range",
      "Start Date should be within 1 year from End Date",
      function (startDate) {
        const { endDate } = this.parent;
        if (startDate && endDate) {
          const diffDays = differenceInDays(
            new Date(endDate),
            new Date(startDate)
          );
          return diffDays <= 365; // 1 year range
        }
        return true;
      }
    ),
  endDate: Yup.string()
    .required("End Date is required")
    .test(
      "is-after-start",
      "End Date cannot be before Start Date",
      function (endDate) {
        const { startDate } = this.parent;
        return startDate ? new Date(endDate) >= new Date(startDate) : true;
      }
    )
    .test(
      "is-in-range",
      "End Date should be within 1 year from Start Date",
      function (endDate) {
        const { startDate } = this.parent;
        if (startDate && endDate) {
          const diffDays = differenceInDays(
            new Date(startDate),
            new Date(endDate)
          );
          return diffDays <= 365; // 1 year range
        }
        return true;
      }
    ),
});
